(() => {
  const MOBILE_MQ = '(max-width: 749px)';
  const SWIPE_THRESHOLD = 40;

  const initSlider = (slider) => {
    const track = slider.querySelector('[data-customsirge-reviews-track]');
    const dots = Array.from(slider.querySelectorAll('[data-customsirge-reviews-dot]'));
    const cards = track ? Array.from(track.children) : [];
    if (!track || cards.length === 0) return;

    const mq = window.matchMedia(MOBILE_MQ);
    let index = 0;
    const count = cards.length;

    const apply = () => {
      if (mq.matches) {
        track.style.transform = `translate3d(${-index * 100}%, 0, 0)`;
      } else {
        track.style.transform = '';
      }
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.setAttribute('data-active', 'true');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.removeAttribute('data-active');
          dot.removeAttribute('aria-selected');
        }
      });
    };

    const goTo = (i) => {
      if (!mq.matches) return;
      index = Math.max(0, Math.min(count - 1, i));
      apply();
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = Number(dot.dataset.index);
        if (!Number.isNaN(i)) goTo(i);
      });
    });

    let startX = 0;
    let isDown = false;

    const onStart = (e) => {
      if (!mq.matches) return;
      isDown = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
    };
    const onEnd = (e) => {
      if (!isDown) return;
      isDown = false;
      if (!mq.matches) return;
      const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      const delta = endX - startX;
      if (Math.abs(delta) < SWIPE_THRESHOLD) return;
      if (delta < 0) goTo(index + 1);
      else goTo(index - 1);
    };

    track.addEventListener('touchstart', onStart, { passive: true });
    track.addEventListener('touchend', onEnd);
    track.addEventListener('pointerdown', onStart);
    track.addEventListener('pointerup', onEnd);
    track.addEventListener('pointercancel', () => { isDown = false; });

    const onChange = () => {
      if (!mq.matches) index = 0;
      apply();
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }

    apply();
  };

  const init = () => {
    document.querySelectorAll('[data-customsirge-reviews-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
